export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-sword-line text-lg text-background-50"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                刃牙漫画
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              刃牙漫画免费全集在线阅读平台，下拉式阅读，全部章节一次畅读。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-50 hover:border-background-500 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-50 hover:border-background-500 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-50 hover:border-background-500 transition-colors">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: '/', label: '首页' },
                { to: '/category/all', label: '全部漫画' },
                { to: '/category/fighting', label: '格斗系列' },
                { to: '/category/gaiden', label: '外传系列' },
                { to: '/about', label: '关于我们' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#" className="hover:text-primary-400 transition-colors">热门作品</a>
            </h4>
            <ul className="space-y-2.5">
              {['刃牙', '刃牙II', '范马刃牙', '刃牙道', '刃牙道II'].map((title) => (
                <li key={title}>
                  <a href="#" className="text-sm text-background-400 hover:text-background-50 transition-colors">
                    {title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                contact@bakimanga.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-wechat-line text-base"></i>
                bakimanga_official
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-qq-line text-base"></i>
                1234567890
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 刃牙漫画 - 免费全集在线阅读平台。本站内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors">使用条款</a>
            <a href="#" className="hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}